module.exports = __webpack_public_path__ + "images/icons_v2/add-d85c4849.svg";